export default __webpack_public_path__ + "static/media/repeat-icon.a5913d98.svg";